import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type ModalConfig = {
  props: Record<string, unknown>;
  visible: boolean;
  id: string | null;
  type: string;
  contentType: string;
  data: {
    title?: string;
    message?: string;
    [key: string]: unknown;
  };
  reOpenModal?: Partial<ModalConfig> | null;
  onClick: (id?: string) => void;
  onClose: (() => void) | null;
  refetch: () => void;
};

type AlertConfig = {
  visible: boolean;
  data: {
    title?: string;
    message?: string;
    [key: string]: unknown;
  };
};

export type CommonStoreState = {
  modalConfig: ModalConfig;
  isLoading: boolean;
  setModalConfig: (data: Partial<ModalConfig>) => void;
  hideCommonModal: () => void;
  setIsLoading: (data: boolean) => void;
  alertConfig: AlertConfig;
  setAlertConfig: (data: AlertConfig) => void;
  hideAlert: () => void;
};

const initialState: CommonStoreState = {
  modalConfig: {
    props: {},
    visible: false,
    id: null,
    type: '',
    contentType: '',
    data: {},
    reOpenModal: null as unknown as ModalConfig,
    onClick: () => {},
    onClose: null,
    refetch: () => {}
  },
  isLoading: false,
  setModalConfig: () => {},
  hideCommonModal: () => {},
  setIsLoading: () => {},
  alertConfig: {
    visible: false,
    data: {}
  },
  setAlertConfig: () => {},
  hideAlert: () => () => {}
};

const useCommonStore = create<CommonStoreState>()(
  devtools(set => ({
    ...initialState,
    setModalConfig: data =>
      set(state => ({
        modalConfig: {
          ...state.modalConfig,
          reOpenModal: null,
          ...data
        }
      })),
    hideCommonModal: () => set({ modalConfig: initialState.modalConfig }),
    setIsLoading: data => set({ isLoading: data }),
    setAlertConfig: data => set({ alertConfig: data }),
    hideAlert: () => set({ alertConfig: initialState.alertConfig })
  }))
);

// ✅ Correct way to use the store's actions
const { setModalConfig, setIsLoading, setAlertConfig, hideAlert } =
  useCommonStore.getState();

export { setModalConfig, setIsLoading, setAlertConfig, hideAlert };
export default useCommonStore;
